import { useMemo } from 'react';

import { GearbeltEvent, GearbeltPlatform, IdBuilder } from '@gearbelt/global';
import { AnalyticsBrowser, EventProperties } from '@segment/analytics-next';
import { Products } from '@site-mate/sitemate-global-shared/lib';

import { env } from '@/environment';
import { useSMSAccountStore } from '@/stores/sms-account.store';
import { useUserStore } from '@/stores/user.store';

const analytics = AnalyticsBrowser.load({
  writeKey: env.segment.writeKey,
});

export function useEvents() {
  const { org, user } = useUserStore();
  const { smsAccount } = useSMSAccountStore();

  const sitemateMetadata = useMemo(
    () => ({
      workspaceId: org?.workspaceId || '',
      workspaceName: org?.name || '',
      sitemateStartAccountId: smsAccount?._id || '',
      sitemateStartAccountName: smsAccount?.name || '',
    }),
    [org, smsAccount],
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function trackEvent(event: GearbeltEvent, properties?: Record<string, any>) {
    const eventProperties: EventProperties = {
      ...properties,
      ...sitemateMetadata,

      Product: Products.Gearbelt,
      platform: GearbeltPlatform.GBW,
      eventId: IdBuilder.UUID(),

      legacyWorkspaceId: org?.id || '',
      userSitemateId: user?.sitemateUserId || '',
      userEmail: user?.email || '',
      environment: env.environment,
      workspaceDataResidency: 'au1',
    };

    if (env.segment.debug) {
      console.log('Sending Segment Track Event with payload:', {
        event,
        eventProperties,
      });
    }

    analytics.track(event, eventProperties, {
      userId: user?.id,
    });
  }

  return {
    trackEvent,
  };
}
